(function () {
  const root = document.querySelector("[data-ext-finder]");
  if (!root) return;

  const dataEl = root.querySelector("[data-ef-products]");
  const grid = root.querySelector("[data-ef-grid]");
  const empty = root.querySelector("[data-ef-empty]");
  const btn = root.querySelector("[data-ef-update]");
  if (!dataEl || !grid || !empty || !btn) return;

  let payload;
  try {
    payload = JSON.parse(dataEl.textContent || "{}");
  } catch {
    payload = { products: [], max_results: 3 };
  }

  const products = Array.isArray(payload.products) ? payload.products : [];
  const maxResults = Number(payload.max_results || 3);

  const envEl = root.querySelector("#ef-env");
  const spaceEl = root.querySelector("#ef-space");
  const finishEl = root.querySelector("#ef-finish");
  const riskChecks = Array.from(root.querySelectorAll('.ext-finder__checks input[type="checkbox"]'));

  function selectedRisks() {
    return riskChecks.filter(c => c.checked).map(c => String(c.value).toLowerCase());
  }

  function toLowerList(v) {
    if (Array.isArray(v)) return v.map(x => String(x).toLowerCase());
    if (typeof v === "string" && v.trim() !== "") return [v.toLowerCase()];
    return [];
  }

  function scoreProduct(p, want) {
    if (!p.available) return -9999;

    const pEnvs = toLowerList(p.envs);
    const pRisks = toLowerList(p.risks);
    const pSpaces = toLowerList(p.space_sizes);

    // HARD MATCHING
    if (want.env && pEnvs.length && !pEnvs.includes(want.env)) return -9999;
    if (want.finish && p.finish && p.finish !== want.finish) return -9999;
    if (want.space && pSpaces.length && !pSpaces.includes(want.space)) return -9999;

    // SCORING
    let score = 0;

    if (pEnvs.includes(want.env)) score += 35;
    if (p.finish === want.finish) score += 15;

    // risk overlap boost
    want.risks.forEach(r => {
      if (pRisks.includes(r)) score += 20;
    });

    // space closeness preference
    const order = { small: 1, medium: 2, large: 3 };
    const w = order[want.space] || 0;
    if (w && pSpaces.length) {
      const distances = pSpaces
        .map(s => Math.abs((order[s] || 0) - w))
        .filter(n => Number.isFinite(n));
      if (distances.length) {
        const d = Math.min(...distances);
        score += 18 - (d * 6);
      }
    }

    return score;
  }

  function render(items) {
    grid.innerHTML = "";

    if (!items.length) {
      empty.style.display = "";
      return;
    }
    empty.style.display = "none";

    items.forEach(p => {
      const tile = document.createElement("div");
      tile.className = "ext-finder__tile";

      const img = document.createElement("img");
      img.className = "ext-finder__img";
      img.loading = "lazy";
      img.alt = p.title || "";
      img.src = p.image || "";
      tile.appendChild(img);

      const body = document.createElement("div");
      body.className = "ext-finder__tile-body";

      const title = document.createElement("h4");
      title.className = "ext-finder__tile-title";
      title.textContent = p.title || "Product";
      body.appendChild(title);

      const price = document.createElement("div");
      price.className = "ext-finder__price";
      price.textContent = "£" + (Number(p.price || 0) / 100).toFixed(2);
      body.appendChild(price);

      const cta = document.createElement("div");
      cta.className = "ext-finder__cta";

      const link = document.createElement("a");
      link.className = "ext-finder__link";
      link.href = p.url || "#";
      link.textContent = "View details";
      cta.appendChild(link);

      const form = document.createElement("form");
      form.method = "post";
      form.action = "/cart/add";

      const id = document.createElement("input");
      id.type = "hidden";
      id.name = "id";
      id.value = String(p.variant_id || "");
      form.appendChild(id);

      const add = document.createElement("button");
      add.type = "submit";
      add.className = "ext-finder__add";
      add.textContent = "Add to cart";
      if (!p.available || !p.variant_id) add.disabled = true;

      form.appendChild(add);
      cta.appendChild(form);

      body.appendChild(cta);
      tile.appendChild(body);

      grid.appendChild(tile);
    });
  }

  function recommend() {
    const want = {
      env: envEl ? String(envEl.value).toLowerCase() : "home",
      space: spaceEl ? String(spaceEl.value).toLowerCase() : "medium",
      finish: finishEl ? String(finishEl.value).toLowerCase() : "red",
      risks: selectedRisks()
    };

    const ranked = products
      .map(p => ({ p, s: scoreProduct(p, want) }))
      .filter(x => x.s > -9999)
      .sort((a, b) => b.s - a.s)
      .slice(0, maxResults)
      .map(x => x.p);

    render(ranked);
  }

  btn.addEventListener("click", recommend);
  recommend();
})();
